let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jlWQP")).then(() => parcelRequire('3qrgQ'));